/**
 * Details html5 component
 * Move focus to the next element of summary when the details is open
 * It will free 'space' key for scrolling
 */
export default function () {
  const details = document.querySelectorAll('details');

  details.forEach((item) => {
    item.addEventListener('toggle', (event) => {
      if (event.target.open) {
        const summary = event.target.querySelector('summary');
        if (summary) {
          summary.nextElementSibling.setAttribute('tabindex', -1);
          summary.blur();
        }
      }
    });
  });
}
